/* ==========================================================================
   Sweet Summer Giveaways — Modal + Scroll Reveal
   ========================================================================== */

(function () {
  'use strict';

  // ---- Modal -------------------------------------------------------------
  function injectEmbed(container, html) {
    container.innerHTML = html;
    // Re-execute any <script> tags that were inserted via innerHTML —
    // ViralSweep typically delivers embed code as a <script> snippet.
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (oldScript) {
      var newScript = document.createElement('script');
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      if (oldScript.text) {
        newScript.text = oldScript.text;
      }
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function openModal(modal) {
    if (!modal) return;
    var body = modal.querySelector('.ss-modal__body');
    if (body && body.dataset.embed && body.dataset.injected !== 'true') {
      injectEmbed(body, body.dataset.embed);
      body.dataset.injected = 'true';
    }
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ss-modal-open');
    var focusable = modal.querySelector('.ss-modal__close');
    if (focusable) focusable.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ss-modal-open');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ss-modal-open]');
    if (trigger) {
      event.preventDefault();
      var id = trigger.getAttribute('data-ss-modal-open');
      var modal = document.getElementById(id);
      openModal(modal);
      return;
    }

    var closer = event.target.closest('[data-ss-modal-close]');
    if (closer) {
      event.preventDefault();
      var dialog = closer.closest('.ss-modal');
      closeModal(dialog);
      return;
    }

    if (event.target.classList && event.target.classList.contains('ss-modal')) {
      closeModal(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.ss-modal[aria-hidden="false"]');
    if (open) closeModal(open);
  });

  // ---- Scroll reveal -----------------------------------------------------
  function initReveal() {
    var sections = document.querySelectorAll('.ss-section[data-animate="true"]');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function (s) { io.observe(s); });
  }

  // ---- Modal portal ------------------------------------------------------
  // .ss-giveaways and .ss-treats have CSS masks applied, which creates a
  // containing block for fixed-position descendants. Move every modal up to
  // document.body so the overlay fills the viewport.
  function portalModals() {
    document.querySelectorAll('.ss-modal').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  // ---- Galleries (Splide) ------------------------------------------------
  function initGalleries() {
    if (typeof Splide === 'undefined') return;
    var galleries = document.querySelectorAll('[data-ss-gallery]');
    galleries.forEach(function (el) {
      if (el.dataset.splideInited === 'true') return;
      el.dataset.splideInited = 'true';
      new Splide(el, {
        type: 'loop',
        perPage: 1,
        pagination: true,
        arrows: true,
        autoplay: false,
        speed: 500,
      }).mount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      portalModals();
      initReveal();
      initGalleries();
    });
  } else {
    portalModals();
    initReveal();
    initGalleries();
  }
})();
